export default "__VITE_PUBLIC_ASSET__bf26ab58__"